module.exports = __webpack_public_path__ + "img/tymmo.afa54859.jpg";